import { EventEmitter } from "../event-emitter";
import { ElectronFunctions } from "./electron";

export interface IElectronNfcSettings {
	requireTagOnStart:boolean;
	scanToLock:boolean;
}

export function getDefaultElectronNfcSettings():IElectronNfcSettings {
	return {
		requireTagOnStart: false,
		scanToLock: false
	};
}

class NfcReaderClass extends EventEmitter {
	public readonly READER_SCANNED_EVENT = "nfc-scanned"
	private initialized:boolean = false;

	public constructor(){
		super();
	}

	public init(){
		if (this.initialized) return;
		this.initialized = true;
		try{
			let ipc = ElectronFunctions.getIpcRenderer();
			ipc.on("nfc-scanned", (event:any, uid:string)=>{
				this.emit(this.READER_SCANNED_EVENT, uid);
			});
		}catch(err){
			console.log("Not electron", err);
		}
	}
}

export const ElectronNfcReader = new NfcReaderClass();
